// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__aXOYo","tooltip-heading":"Tooltip_tooltip-heading__QvwBc","tooltip-text":"Tooltip_tooltip-text__oWzGc"};